/**
 *
 * @param {String} title Page Title
 * @param {String} description Page Description
 * @param {String} route Page Route
 * @returns {Object} { title: string, meta: [{ name: string, content: string }]}
 */
const buildMeta = ({ title, description, route }) => {
  return {
    title: title,
    meta: [
      {
        name: 'description',
        content: description
      },
      {
        name: 'og:title',
        content: title
      },
      {
        name: 'og:url',
        content: `http://localhost:3000/${route}`
      },
      {
        name: 'og:description',
        content: description
      }
    ]
  }
}

const meta = {
  twitch: buildMeta({
    title: 'Twitch',
    description: 'View Twitch',
    route: '/twilio'
  }),
  home: buildMeta({
    title: 'Stew',
    description: 'Play Bender Games',
    route: '/'
  })
}

export default meta
